import { attendanceActions } from "../slices/attendanceSlice";
import axios from "axios";
import { toast } from "react-toastify";

// ----------------- Check In -----------------
export function userCheckInApi() {
  return async (dispatch, getState) => {
    try {
      const token = getState().auth.user.token;

      const { data } = await axios.post(
        "https://remote-attendance.hsagroup.info/api/attendance/check-in",
        {}, 
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(attendanceActions.setUserCheckIn({ attendance: data.attendance }));
      console.log("CHECK-IN RESPONSE:", data);

    } catch (error) {
      toast.error(error.response?.data?.message || "Check-in failed");
      console.log(error);
    }
  };
}

// ----------------- Check Out -----------------
export function userCheckOutApi() {
  return async (dispatch, getState) => {
    try {
      const token = getState().auth.user.token;

      const { data } = await axios.post(
        "https://remote-attendance.hsagroup.info/api/attendance/check-out",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(attendanceActions.setUserCheckOut({ attendance: data.attendance }));
      console.log("CHECK-OUT RESPONSE:", data);

    } catch (error) {
      toast.error(error.response?.data?.message || "Check-out failed");
      console.log(error);
    }
  };
}

// ----------------- Get Today Attendance -----------------
export function getTodayAttendanceApi() {
  return async (dispatch, getState) => {
    try {
      const token = getState().auth.user.token;

      const { data } = await axios.get(
        "https://remote-attendance.hsagroup.info/api/attendance/today",
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (data.attendance) {
        dispatch(attendanceActions.setUserCheckIn({ attendance: data.attendance }));
        dispatch(attendanceActions.setUserCheckOut({ attendance: data.attendance }));
      }

    } catch (error) {
      toast.error(error.response?.data?.message);
      console.log(error);
    }
  };
}

// ----------------- Get Attendance By Date -----------------
export function getAttendanceByDateApi(date) {
  return async (dispatch, getState) => {
    try {
      const token = getState().auth.user.token;

      const { data } = await axios.get(
        `https://remote-attendance.hsagroup.info/api/attendance/by-date?date=${date}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(attendanceActions.setYesterdayAttendance(data.attendance));

    } catch (error) {
      toast.error(error.response?.data?.message);
      console.log(error);
    }
  };
}

// ----------------- Fetch JSON Attendance Report -----------------
export function getAllAttendanceReportApi({ startDate, endDate, userId = "all", department = "all" }) {
  return async (dispatch, getState) => {
    try {
      dispatch(attendanceActions.startLoading());

      const token = getState().auth.user?.token;

      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      queryParams.append("userId", userId);       // always send "all" if not filtering
      queryParams.append("department", department); // always send "all" if not filtering
      queryParams.append("format", "json");

      const { data } = await axios.get(
        `https://remote-attendance.hsagroup.info/api/attendance/attendance-report?${queryParams.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(attendanceActions.setAttendanceReport(data.data || []));
      dispatch(attendanceActions.stopLoading());
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch(attendanceActions.setError(message));
      dispatch(attendanceActions.stopLoading());
      toast.error(message);
      console.log(error);
    }
  };
}

// ----------------- Export CSV -----------------
export function exportAttendanceReportCsvApi({ startDate, endDate, userId, department }) {
  return async (dispatch, getState) => {
    try {
      const token = getState().auth.user?.token;

      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (userId) queryParams.append("userId", userId);
      if (department) queryParams.append("department", department);
      queryParams.append("format", "csv");

      const response = await axios.get(
        `https://remote-attendance.hsagroup.info/api/attendance/attendance-report?${queryParams.toString()}`,
        { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" }
      );

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "attendance_report.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error("Failed to export CSV");
      console.log(error);
    }
  };
}

// ----------------- Export PDF -----------------
export function exportAttendanceReportPdfApi({ startDate, endDate, userId, department }) {
  return async (dispatch, getState) => {
    try {
      const token = getState().auth.user?.token;

      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (userId) queryParams.append("userId", userId);
      if (department) queryParams.append("department", department);
      queryParams.append("format", "pdf");

      const response = await axios.get(
        `https://remote-attendance.hsagroup.info/api/attendance/attendance-report?${queryParams.toString()}`,
        { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "attendance_report.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error("Failed to export PDF");
      console.log(error);
    }
  };
}
